/**
 * Toast system — single source of truth for durations and defaults.
 *
 * Consolidates drifting constants:
 * - useToast.ts:33           → 3000 (default duration)
 * - useTable/constants.ts:DEFAULT_TOAST_DURATION → 4000
 * - mercureSubscriptions.ts:51 → 3000 (notification toast)
 */

export type ToastPosition =
  | "top-left"
  | "top-right"
  | "top-center"
  | "bottom-left"
  | "bottom-right"
  | "bottom-center";

export const TOAST_DEFAULTS = {
  duration: 3000,
  errorDuration: 5000,
  maxToasts: 5,
  position: "bottom-right" as const,
} as const;

/**
 * Resolve toast duration from optional uiSettings override.
 * Returns the override value if provided and valid, else falls back to default.
 */
export const resolveDuration = (override?: number | null): number => {
  if (typeof override === "number" && override > 0) {
    return override;
  }
  return TOAST_DEFAULTS.duration;
};
